import { render, staticRenderFns } from "./RentalCarRepairShopPricingCard.vue?vue&type=template&id=21d6bb08&scoped=true"
import script from "./RentalCarRepairShopPricingCard.vue?vue&type=script&lang=js"
export * from "./RentalCarRepairShopPricingCard.vue?vue&type=script&lang=js"
import style0 from "./RentalCarRepairShopPricingCard.vue?vue&type=style&index=0&id=21d6bb08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d6bb08",
  null
  
)

export default component.exports